import {UHttp} from "../utils/UHttp"


export interface AuthCredentials {
    email: string;
    password: string;
}

export interface RegisterCredentials {
    firstName: string
    lastName: string,
    email: string;
    password: string;
    confirmPassword: string;
    //acceptTerms: boolean;
    //acceptPrivacy: boolean;
}

export interface AuthResponse {
    success: boolean,
    message: string,
    token: {token: string; refreshToken: string },
    status?: number,
    user: {
        "id": string,
    }
}

const apiUrlServer = process.env.REACT_APP_URL_SERVER;

export class AuthModel {
    private static instance: AuthModel;

    private constructor() {}

    public static getInstance(): AuthModel {
        if (!AuthModel.instance) {
            AuthModel.instance = new AuthModel();
        }
        return AuthModel.instance;
    }

    public async handleLogin(credentials: AuthCredentials): Promise<AuthResponse> {
        try {
            // Utiliser fetch directement pour éviter le mécanisme d'interception de UHttp
            // qui provoque des rechargements de page en cas d'erreur 401
            const response = await fetch(
                apiUrlServer + "/api/auth/login", 
                {
                    method: "POST",
                    body: JSON.stringify(credentials),
                    headers: UHttp.defaultHeaders()
                }
            );

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };
            
        } catch (error: any) {
            console.error('Erreur login:', error);
            return {
                success: false,
                message: error.message || 'Erreur de connexion',
                token: { token: '', refreshToken: '' },
                status: 500,
                user: { id: '' }
            };
        }
    }
    public async handleRegister(credentials: RegisterCredentials): Promise<AuthResponse> {
        try {
            const response = await UHttp.post(
                apiUrlServer + "/api/auth/register",
                credentials,
                UHttp.defaultHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleVerifyToken(): Promise<Response> {
        try {
            const response = await UHttp.get(
                apiUrlServer + "/api/auth/verify-token",
                UHttp.authHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleForgotPassword( email: string): Promise<any> {
        try {
            const response = await UHttp.post(
                apiUrlServer + "/public-api/auth/forgot-password",
                {email: email},
                UHttp.publicApiHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleVerifyResetToken(token: string): Promise<any> {
        try {
            const response = await UHttp.get(
                `${apiUrlServer}/public-api/auth/verify-reset-token?token=${token}`,
                UHttp.publicApiHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleResetPassword( tokenParam: string, password: string, confirmPassword: string): Promise<any> {
        try {
            const response = await UHttp.post(
                apiUrlServer + "/public-api/auth/reset-password",
                { token: tokenParam, password, confirmPassword },
                UHttp.publicApiHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleEmailVerification( token: string): Promise<any> {
        try {
            const response = await UHttp.get(`${apiUrlServer}/public-api/auth/verify-email?token=${token}`, UHttp.publicApiHeaders())

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleResendEmailVerification( email: string): Promise<any> {
        try {
            const response = await UHttp.post(
                apiUrlServer + "/public-api/auth/resend-verification-email",
                { email },
                UHttp.publicApiHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            throw error;
        }
    }
    public async handleLogout(): Promise<Response> {
        try {
            const response = await UHttp.get(
                apiUrlServer + "/api/auth/logout",
                UHttp.authHeaders()
            )

            const responseData = await response.json();
            return {
                ...responseData,
                status: response.status
            };

        } catch (error: any) {
            console.error('Error AuthModel.handleLogout:', error.data);
            throw error;
        }
    }
}